import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import Button from "../../Elements/Button/Button.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import SendMailToVerify from "../../Pages/RegistrationComplete/SendMailToVerify.js";
import parse from "html-react-parser";

const ConfirmUserMessage = ({ setFullScreenMessage, fullScreenMessage }) => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const { setModal } = useModal();

  let subTitleText = parse(
    getTextByKey("user-not-confirm").replace(
      "#EmailAdress#",
      getUserData().UserName
    )
  );

  return (
    <div className="mail-message-container confirm-user-container">
      <div className="title">{getTextByKey("user-not-confirm-title")}</div>
      <div className="sub-title">{subTitleText}</div>
      <Button
        medium
        onClick={() =>
          setModal(() => <SendMailToVerify userData={getUserData()} />)
        }
      >
        {parse(getTextByKey("resend-confirm-user-button"))}
      </Button>
    </div>
  );
};

export default ConfirmUserMessage;
